import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey, getUnionModule } from '@/views/custom-layout/api';
export default {
  name: 'saas_module_plate_swipe_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        type: [{
          required: true,
          message: '请选择头部配置方式',
          trigger: 'change'
        }],
        image_style: [{
          required: true,
          message: '请选择侧滑楼层图片样式',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '顶部不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        header_image: [{
          required: true,
          message: '头部图片不可为空',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }],
        module_plate_id: [{
          required: true,
          message: '活动板块不可为空'
        }],
        activity_num: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!/^[0-9]*$/.test(value)) {
              callback('仅支持正整数');
            } else if (value > 99 || value < 1) {
              callback('仅支持1-99正整数');
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      },
      moduleList: [],
      showPictureLibrary: false,
      pictureList: [],
      depot: {}
    };
  },
  methods: {
    changeModule: function changeModule(val) {
      var data = this.moduleList.find(function (i) {
        return i.id === val;
      });
      if (data) {
        var module_id = data.module_id,
          module_type = data.module_type,
          open_module_type = data.open_module_type;
        this.value.config.module_id = module_id;
        this.value.config.module_type = module_type;
        this.value.config.open_module_type = open_module_type;
      }
    },
    getUnionModuleList: function getUnionModuleList() {
      var _this = this;
      // 获取SaaS板块下拉数据
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      getUnionModule({
        customer_id: customer_id
      }, module).then(function (res) {
        _this.moduleList = res.data;
      });
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this2 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this2.pictureList = picture[1] || [];
        _this2.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.$set(this.value.config, 'header_image', path);
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      // pictureList: 图库中图片列表
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(refName) {
      this.$refs[refName].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(prop, url) {
      this.$set(this.value.config, prop, "".concat(this.$ossurl).concat(url));
    },
    onDelete: function onDelete(prop) {
      var _this3 = this;
      if (!this.value.config[prop]) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this3.$set(_this3.value.config, prop, '');
      });
    }
  },
  created: function created() {
    this.getPicture();
    this.getUnionModuleList();
    this.$set(this.value, 'config', _objectSpread(_objectSpread({
      type: '1',
      name: '',
      more_name: '查看更多',
      bg_color: '#ffffff',
      module_id: '',
      module_type: '',
      open_module_type: '',
      module_plate_id: '',
      activity_num: '5',
      margin_top: 15,
      z_index: 2,
      image_style: '1'
    }, this.value.config_default_value), this.value.config));
  }
};